export enum MarkType {
	BOLD = 'bold',
	ITALIC = 'italic',
	UNDERLINE = 'underline',
	STRIKE_THROUGH = 'strike_through',
	CODE = 'code',
	SPOILER = 'spoiler',
	LINK = 'link'
}

export enum BlockType {
	PARAGRAPH = 'paragraph',
	HEADING = 'heading',
	CODE_LINE = 'code_line',
	CODE_BLOCK = 'code_block',
	QUOTE_LINE = 'quote_line',
	BLOCK_QUOTE = 'block_quote',
	LIST_ITEM = 'list_item',
	ORDERED_LIST = 'ordered_list',
	UNORDERED_LIST = 'unordered_list',
	MENTION = 'mention',
	EMOTICON = 'emoticon',
	COMMAND = 'command'
}

export enum AutocompletePrefix {
	ROOM_MENTION = '#',
	USER_MENTION = '@',
	EMOTICON = ':',
	COMMAND = '/'
}
